import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { any, prop, __, isEmpty, concat, sort, path, assoc, filter, find } from 'ramda';
import Translate from 'react-translate-component';
import cx from 'classnames';
import { Row } from 'antd';

import { openModalEvent, openModalPerson, openModalSotrMeetUpdate, openModalProject,  openModalCompany, openModalEducationEvent } from 'actions/modalActions';
import { notEmpty } from 'utils/ramdaAdditions';
import { DATE_FORMATS } from 'constants/dateFormats';
import { PERIODS } from 'constants/calendar';
import EventItem from './EventItem';
import EducationEventItem from './EducationEventItem';

const mapDispatchToProps = { openModalEvent, openModalPerson, openModalSotrMeetUpdate, openModalProject, openModalCompany, openModalEducationEvent };
const isFiltersNotSelected = ({ planner, filters }) => !planner && isEmpty(filters);

const getTimeFrom = path(['dt', 'time', 'from']);
const setTimeFrom = assoc('timeFrom');

const transformEvents = (items) => items.map(event => !event.type ? setTimeFrom(getTimeFrom(event), event) : event);

const isAnyAllday = (first, second) => !first.timeFrom || !second.timeFrom;
const allDayBefore = (first, second) => !second.timeFrom ? 1 : -1;
const earlierBefore = (first, second) => first.timeFrom - second.timeFrom;
const sortEvents = sort((firstEvent, secondEvent) => {
    const [ first, second ] = transformEvents([firstEvent, secondEvent]);
    return isAnyAllday(first, second) ? allDayBefore(first, second) : earlierBefore(first, second);
});

const isUniq = educationItems => ({ id }) => !find(item => item.id === id, educationItems);
const concatUniq = (educationItems, trainerItems) => concat(educationItems, filter(isUniq(educationItems), trainerItems));

@connect(null, mapDispatchToProps)
export default class EventList extends Component {
    isShowEvent = ({ filter: { planer, ...eventTagList } } ) => {
        const { planner, filters } = this.props;
        if (planner) {
            return planer;
        } else {
            return any(prop(__, eventTagList))(filters);
        }
    };

    filterEducationTimesheet = (days = []) => {
        const { education } = this.props;

        return education ? days : days.filter(({ type }) => !!type);
    }

    renderEventItems = ({ date, meetList = [] }) => {
        const { period, currentId, isAllowedToEdit, timesheetDays, trainerDays } = this.props;
        const { openModalEvent, openModalPerson,  openModalSotrMeetUpdate, openModalProject, openModalCompany, openModalEducationEvent } = this.props;

        const calendarItems = meetList.filter(this.isShowEvent);
        const educationItems = this.filterEducationTimesheet(timesheetDays[date]);
        const trainerItems = this.filterEducationTimesheet(trainerDays[date]);

        const items = concat(calendarItems, concatUniq(educationItems, trainerItems));

        const emptyMessage = isFiltersNotSelected(this.props) ? "calendar.filtersNotSelected" : "calendar.no_events";
        const sortedEvents = sortEvents(items);

        return notEmpty(sortedEvents) ? (
            sortedEvents.map((event, index) => (
                <div key={`${event.id}_${event.key}`}>
                    { event.type ? (
                        <EventItem
                            order={index + 1}
                            openModalEvent={openModalEvent}
                            openModalPerson={openModalPerson}
                            openModalSotrMeetUpdate={openModalSotrMeetUpdate}
                            openModalProject={openModalProject}
                            openModalCompany={openModalCompany}
                            event={event}
                            date={date}
                            currentId={currentId}
                            isAllowedToEdit={isAllowedToEdit}
                        />
                    ) : (
                        <EducationEventItem
                            order={index + 1}
                            event={event}
                            openModalPerson={openModalPerson}
                            openModalEducationEvent={openModalEducationEvent}
                        />
                    )}
                    {period === PERIODS.DAY && (
                        <div className="calendar-empty-row" />
                    )}
                </div>
            ))
        ) : (
            <Row className="calendar-row calendar-row_no-data">
                <Translate content={emptyMessage} />
            </Row>
        );
    };

    render() {
        const { days } = this.props;

        return (
            <div>
                {days && days.map((day, index) => (
                    <div key={index} className={cx('calendar-day', { 'calendar-day_active' : moment(day.date).isSame(moment(), 'day') })}>
                        <div className="calendar-title">
                            {moment(day.date).format(DATE_FORMATS.dayOfWeekDayMonthFormat)}
                        </div>
                        {this.renderEventItems(day)}
                    </div>
                ))}
            </div>
        );
    }
}
